import { connect } from "react-redux";
import * as actions from "./actions";
import _ from "underscore";

function mapStateToProps(state) {
  return { orders: state.orders };
}

function mapDispatchToProps(dispatch) {
  return {
    registerBonusPayments: (bonus, depotId) => {
      dispatch(actions.register_bonus(bonus, depotId));
    },

    fetchCreatedBonusPayments: () => {
      dispatch(actions.fetch_created_bonuses());
    },

    confirmBonusPayment: (bonusId) => {
      dispatch(actions.confirm_bonus(bonusId));
    },

    cancelBonusOrder: (bonusId) => {
      dispatch(actions.cancel_bonus_order(bonusId));
    },
  };
}

export const orderConnector = connect(mapStateToProps, mapDispatchToProps);

export const withBonusFiltered = (Cmp) => (props) => {
  if (props.accountId && props.orders.bonus.fetched) {
    let userBonuses = _.filter(props.orders.bonus.data, (item) => {
      return item.InvestorId === props.accountId;
    });

    let newOrders = Object.assign({}, props.orders, {
      bonus: Object.assign({}, props.orders.bonus, {
        data: [...userBonuses],
      }),
    });

    let newProps = { ...props, orders: newOrders };

    return <Cmp {...newProps} />;
  }

  return <Cmp {...props} />;
};
